<div
    class="box-border min-h-[6.5rem] pb-1 pt-1 text-black"
    [attr.aria-label]="journeyAriaLabel"
    [attr.tabindex]="itineraryDetailsPage ? 0 : null"
    [ngClass]="itinerary?.isMostOptimal && !hasDeparted ? 'bg-theme_green bg-opacity-10' : ''"
    role="group">
    <div class="flex justify-between px-4" aria-hidden="true">
        <ng-container
            [ngTemplateOutlet]="
                isDelayedThreshold ? timeWithDelay : isRealtime && isDelayed ? realtime : time
            "></ng-container>

        <p
            class="flex flex-shrink-0 items-center gap-1"
            [ngClass]="{ 'text-danger': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && isCancelledTrip }">
            <ion-icon
                class="text-base"
                *ngIf="env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && isCancelledTrip"
                src="{{ assetsPath$ | async }}/img/alert-cancelled.svg"></ion-icon>
            <ion-icon
                class="var-app-light-dark:scale-[1.2] var-app-light:text-white drt-icon-text-color mr-1 text-base dark:text-contrast-yellow"
                *ngIf="isFlexibleTrip"
                title="{{ 'FLEXIBLE' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/drt-route-icon.svg"></ion-icon>
            <ion-icon
                class="realtime-icon var-app-light:text-black orb-app-light:text-black mr-1 dark:text-contrast-yellow"
                *ngIf="isRealtime && !env.JOURNEY_PLANNER?.REALTIME_ICON_HIDDEN"
                title="{{ 'LIVE' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/live.svg"></ion-icon>
            <ion-icon
                class="mr-1"
                *ngIf="hasFootnote"
                title="{{ 'INFO' | translate }}"
                src="{{ assetsPath$ | async }}/img/explore/icon-info.svg"></ion-icon>
            <ng-container *ngIf="isDisrupted" [ngSwitch]="isDisruptedWithSeverity">
                <ion-icon
                    class="var-app-dark:text-black orb-app-dark:text-black text-red-alert_icon orb-app-light:text-red-alert_icon"
                    *ngSwitchCase="DisruptionMessageSeverity.CRITICAL"
                    title="{{ 'ALERT' | translate }}"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-alert-circle.svg"></ion-icon>

                <ion-icon
                    class="text-blue-alert_icon var-app-dark:text-black orb-app-dark:text-black"
                    *ngSwitchCase="DisruptionMessageSeverity.INFO"
                    title="{{ 'ALERT' | translate }}"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-info-no-color.svg"></ion-icon>

                <!-- WARNING (default) -->
                <ion-icon
                    class="var-app-light:text-yellow-secondary dark:text-contrast-yellow"
                    *ngSwitchDefault
                    title="{{ 'ALERT' | translate }}"
                    src="{{ assetsPath$ | async }}/img/journey-planner/alert.svg"></ion-icon>
            </ng-container>
            <span class="text-base text-black dark:text-contrast-yellow">
                <span [attr.aria-hidden]="true">{{ itinerary?.duration * 1000 | duration }}</span>
            </span>
        </p>
    </div>
    <div
        class="plan orb-app-light-dark:pb-2 var-app-light-dark:pb-2 mt-2 flex items-center overflow-x-auto px-4 focus:outline-none"
        aria-hidden="true">
        <ng-container *ngFor="let leg of itinerary?.legs ?? []; let last = last">
            <div class="flex items-center">
                <div
                    class="flex min-w-[0.75rem] items-center justify-center text-xs font-bold"
                    *ngIf="leg.routeShortName"
                    [rwidgetShape]="leg.icon?.shape"
                    [shapeText]="leg.routeShortName"
                    [ngStyle]="{
                        'color':
                            (highContrast$ | async)
                                ? '#000000'
                                : otpUtil.resolveColor(leg?.icon?.textColor || leg.routeTextColor, 'white'),
                        'background-color':
                            (highContrast$ | async)
                                ? '#FFFF00'
                                : otpUtil.resolveColor(leg?.icon?.color || leg.routeColor),
                        'border-color':
                            (highContrast$ | async)
                                ? '#FFFF00'
                                : otpUtil.resolveColor(leg?.icon?.color || leg.routeColor)
                    }"></div>
                <span class="flex items-start" *ngIf="leg.mode === transportModeEnum.Wait">
                    <mat-icon class="border-black text-black dark:text-contrast-yellow" [attr.aria-hidden]="true"
                        >schedule</mat-icon
                    >
                    <span
                        class="items-center justify-center text-xs leading-none dark:text-contrast-yellow"
                        [attr.aria-hidden]="true"
                        >{{ getMinutesDuration(leg.duration) }}</span
                    >
                </span>

                <span class="flex items-start" *ngIf="leg.mode === transportModeEnum.Walk">
                    <ion-icon
                        class="filter-black text-xl dark:filter-yellow"
                        title="{{ 'ITINERARY_INSTRUCTIONS_WALK' | translate }}"
                        src="{{ assetsPath$ | async }}/img/journey-planner/walk.svg"></ion-icon>

                    <span class="text-xs leading-none dark:text-contrast-yellow">{{
                        getMinutesDuration(leg.duration)
                    }}</span>
                </span>
                <ion-icon
                    class="journey-itinerary__chevron mx-1 h-5 w-5 text-grey-dark dark:text-contrast-yellow"
                    *ngIf="!last"
                    aria-hidden="true"
                    name="chevron-forward"></ion-icon>
            </div>
        </ng-container>
    </div>
    <div class="mb-2 flex h-4 px-4 align-middle" *ngIf="summary === 'default' && itinerary" aria-hidden="true">
        <p class="text-xs text-black dark:text-contrast-yellow">
            <ng-container *ngIf="showLeavesIn && !timeBetweenIncludes && !this.env.JOURNEY_PLANNER?.HIDE_LEAVES_IN">
                {{ 'ITINERARY_INSTRUCTIONS_GO_IN' | translate }}
                {{
                    otpUtil.unixToDate(_currentTime, timeZone).epochMilliseconds
                        | timeBetweenDates: otpUtil.unixToDate(itinerary?.startTime, timeZone).epochMilliseconds
                }}
                <span class="text-black dark:text-contrast-yellow">•&nbsp;</span>
            </ng-container>
            <ng-container
                *ngIf="{
                    value:
                        !showLeavesIn &&
                        !timeBetweenIncludes &&
                        !hasDeparted &&
                        !isOverOneHour &&
                        !this.env.JOURNEY_PLANNER?.HIDE_LEAVE_NOW
                } as isLeaveNowCondition">
                <span *ngIf="isLeaveNowCondition.value">
                    {{ 'LEAVE_NOW' | translate }}
                </span>
                <span
                    class="journey-itinerary__board text-xs text-grey-dark dark:text-contrast-yellow"
                    *ngIf="(isRealtime || (!isRealtime && getBoardAt)) && !hasDeparted && !isLeaveNowCondition.value">
                    {{ 'BOARD_AT' | translate }}
                    {{ getBoardAt | date: 'HH:mm' : timeZoneOffset }}
                </span>
            </ng-container>
            <span *ngIf="hasDeparted">
                {{ 'DEPARTED' | translate }}
            </span>
            <ng-container *ngIf="itinerary?.changes > 0">
                <span class="text-black dark:text-contrast-yellow">&nbsp;•&nbsp;</span>
                <span class="journey-itinerary__board text-xs text-grey-dark dark:text-contrast-yellow">
                    {{
                        itinerary.changes > 1
                            ? ('JOURNEY_PLANNER_CHANGE_MANY' | translate: { count: itinerary.changes })
                            : ('JOURNEY_PLANNER_CHANGE_ONE' | translate: { count: itinerary.changes })
                    }}
                </span>
            </ng-container>
        </p>
    </div>
    <div class="px-4" aria-hidden="true">
        <div
            class="gl-light:bg-orange-alert mt-2 box-border flex w-full items-center gap-3 rounded-lg bg-yellow-alert px-2.5 py-2"
            *ngIf="isDisrupted && env.JOURNEY_PLANNER?.SHOW_GENERAL_DISRUPTION_MESSAGE && itineraryDetailsPage">
            <ion-icon
                class="dark:filter-yellow"
                size="large"
                title="{{ 'ALERT_DETAILS' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/alert-details.svg"></ion-icon>
            <p class="text-sm font-light leading-5">{{ 'DISRUPTION_MESSAGE_GENERAL_HEADER' | translate }}</p>
        </div>
    </div>
</div>

<ng-template #timeWithDelay>
    <div class="grid grid-cols-[auto_min-content_auto] justify-start gap-x-1">
        <p class="col-span-3 row-start-1 text-base font-bold leading-6 dark:text-contrast-yellow">
            <span [ngClass]="{ italic: isDepartureApproximateTime }">{{
                realdataStartTime | date: 'HH:mm' : timeZoneOffset
            }}</span>
            -
            <span [ngClass]="{ italic: isArrivalApproximateTime }">{{
                realdataEndTime | date: 'HH:mm' : timeZoneOffset
            }}</span>
        </p>

        <ng-container *ngIf="isDepartureThresholdExceeded || isArrivalThresholdExceeded">
            <p
                class="col-span-3 row-start-2 justify-self-center text-sm font-bold leading-5 text-[#414141] line-through dark:text-contrast-yellow"
                *ngIf="isDepartureThresholdExceeded && isArrivalThresholdExceeded">
                {{ itinerary?.startTime | date: 'HH:mm' : timeZoneOffset }} -
                {{ itinerary?.endTime | date: 'HH:mm' : timeZoneOffset }}
            </p>

            <ng-container *ngIf="!(isDepartureThresholdExceeded && isArrivalThresholdExceeded)">
                <p
                    class="col-start-1 row-start-2 text-sm font-bold leading-5 text-[#414141] line-through dark:text-contrast-yellow"
                    *ngIf="isDepartureThresholdExceeded">
                    {{ itinerary?.startTime | date: 'HH:mm' : timeZoneOffset }}
                </p>
                <p
                    class="col-start-3 row-start-2 text-sm font-bold leading-5 text-[#414141] line-through dark:text-contrast-yellow"
                    *ngIf="isArrivalThresholdExceeded">
                    {{ itinerary?.endTime | date: 'HH:mm' : timeZoneOffset }}
                </p>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #realtime>
    <div class="flex flex-row gap-1">
        <div class="grid grid-cols-[auto_min-content_auto] items-baseline gap-x-1">
            <p
                class="col-span-3 row-start-1 text-base font-bold leading-5 dark:text-contrast-yellow"
                [ngClass]="{ 'text-danger': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && isCancelledTrip }">
                <span [ngClass]="{ italic: isDepartureApproximateTime }">{{
                    realdataStartTime | date: 'HH:mm' : timeZoneOffset
                }}</span>
                -
                <span [ngClass]="{ italic: isArrivalApproximateTime }">{{
                    realdataEndTime | date: 'HH:mm' : timeZoneOffset
                }}</span>
            </p>

            <ng-container *ngIf="isDepartureThresholdExceeded || isArrivalThresholdExceeded">
                <p
                    class="col-span-3 row-start-2 justify-self-center text-sm leading-5 text-grey-zambezy line-through dark:text-contrast-yellow"
                    *ngIf="isDepartureThresholdExceeded && isArrivalThresholdExceeded"
                    [ngClass]="{ 'ml-3': !itinerary.journeyStartDepartureDelay }">
                    {{ itinerary?.startTime | date: 'HH:mm' : timeZoneOffset }} -
                    {{ itinerary?.endTime | date: 'HH:mm' : timeZoneOffset }}
                </p>

                <p
                    class="col-start-1 row-start-2 text-sm leading-5 text-grey-zambezy line-through dark:text-contrast-yellow"
                    *ngIf="isDepartureThresholdExceeded && !isArrivalThresholdExceeded"
                    [ngClass]="{ 'ml-3': !itinerary.journeyStartDepartureDelay }">
                    {{ itinerary?.startTime | date: 'HH:mm' : timeZoneOffset }}
                </p>

                <p
                    class="col-start-3 row-start-2 text-sm leading-5 text-grey-zambezy line-through dark:text-contrast-yellow"
                    *ngIf="isArrivalThresholdExceeded && !isDepartureThresholdExceeded">
                    {{ itinerary?.endTime | date: 'HH:mm' : timeZoneOffset }}
                </p>
            </ng-container>
        </div>

        <ion-icon
            class="h-6 w-6 text-black dark:text-contrast-yellow"
            *ngIf="isOptimalJourneyIconVisible"
            src="{{ assetsPath$ | async }}/img/journey-planner/tick.svg"></ion-icon>
    </div>
</ng-template>

<ng-template #time>
    <div class="flex flex-row items-center gap-1">
        <ng-container
            *ngIf="itinerary.legs[0].departureDelay || itinerary.legs[0].arrivalDelay; else originalEstimatedTime">
            <ng-container [ngTemplateOutlet]="delayedTime"></ng-container>
        </ng-container>
        <ion-icon
            class="h-6 w-6 text-black dark:text-contrast-yellow"
            *ngIf="isOptimalJourneyIconVisible"
            src="{{ assetsPath$ | async }}/img/journey-planner/tick.svg"></ion-icon>
    </div>
</ng-template>

<ng-template #originalEstimatedTime>
    <ng-container
        [ngTemplateOutlet]="timeDisplay"
        [ngTemplateOutletContext]="{
            isDelayed: false,
            departure: itinerary?.startTime,
            arrival: itinerary?.endTime
        }"></ng-container>
</ng-template>

<ng-template #delayedTime>
    <div>
        <!-- Estimate with delays -->
        <ng-container
            [ngTemplateOutlet]="timeDisplay"
            [ngTemplateOutletContext]="{
                isDelayed: false,
                departure: itinerary?.startTime + itinerary.legs[0].departureDelay * 1000,
                arrival: itinerary?.endTime + itinerary.legs[0].arrivalDelay * 1000
            }"></ng-container>
        <!-- Original estimate -->
        <ng-container
            [ngTemplateOutlet]="timeDisplay"
            [ngTemplateOutletContext]="{
                isDelayed: true,
                departure: itinerary?.startTime,
                arrival: itinerary?.endTime
            }"></ng-container>
    </div>
</ng-template>

<ng-template #timeDisplay let-isDelayed="isDelayed" let-departure="departure" let-arrival="arrival">
    <p
        class="leading-5 dark:text-contrast-yellow"
        [ngClass]="{
            'text-danger': env.JOURNEY_PLANNER?.SHOW_CANCELLED_STATUS && isCancelledTrip,
            'text-base font-bold': !isDelayed,
            'text-sm line-through': isDelayed
        }">
        <span [attr.aria-hidden]="true" [ngClass]="{ italic: isDepartureApproximateTime }">
            {{ departure | date: 'HH:mm' : timeZoneOffset }}
        </span>
        -
        <span [attr.aria-hidden]="true" [ngClass]="{ italic: isArrivalApproximateTime }">
            {{ arrival | date: 'HH:mm' : timeZoneOffset }}
        </span>
    </p>
</ng-template>
